import { useEffect } from 'react';

import { BRAND_NAME } from './brand';

/** The home page's title; also the static fallback in index.html. */
export const HOME_TITLE = `${BRAND_NAME} — financial news sentiment`;

/**
 * Sets the browser tab title for the current page ("AAPL sentiment ·
 * AIFin Sentiment"). A single-page app never reloads, so without this every
 * route shares one title in tabs, history, and screen-reader announcements.
 */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} · ${BRAND_NAME}` : HOME_TITLE;
  }, [title]);
}
